// Edit Modal functionality
window.setupEditModal = function setupEditModal() {
    const editBtn = document.getElementById("editThemeInModal");
    const editModal = document.querySelector(".abs-top-right-edit");
    const closeEditBtns = document.querySelectorAll(".edit-modal-close");

    if (!editBtn || !editModal || !closeEditBtns.length) {
        // console.log("Edit modal elements not found");
        return;
    }

    // Function to show edit modal
    function showEditModal() {
        editModal.classList.add("show");
        
        // Prevent body scroll
        document.body.style.overflow = "hidden";
        
        // Prevent scroll on theme preview and card content
        const themePreview = document.getElementById("themePreview");
        const invitationCard = document.getElementById("invitationCard");
        const cardWrapper = document.querySelector(".card-wrapper");
        
        if (themePreview) {
            themePreview.classList.add("modal-open");
        }
        if (invitationCard) {
            invitationCard.classList.add("modal-open");
        }
        if (cardWrapper) {
            cardWrapper.classList.add("modal-open");
        }

        // Animate modal backdrop
        gsap.fromTo(
            editModal,
            { opacity: 0 },
            { opacity: 1, duration: 0.4, ease: "power2.out" }
        );

        // Animate form elements with stagger
        animateFormElements();
    }

    // Function to animate form elements
    function animateFormElements() {
        // Get the active form container (support both tab-pane and model systems)
        let activeForm = document.querySelector('.tab-pane.active .form-container');
        
        // Fallback to model-based system
        if (!activeForm) {
            activeForm = document.querySelector('[data-model][data-state="show"] .form-container');
        }
        
        if (!activeForm) return;

        // Get all animatable elements in order
        const formHeader = activeForm.querySelector('.form-header');
        const formImages = activeForm.querySelectorAll('img');
        const formGroups = activeForm.querySelectorAll('.form-group, .row:has(.form-group), .mb-3:has(.form-control)');
        const formButtons = activeForm.querySelector('.form-footer');

        // Create timeline for smooth sequential animation
        const tl = gsap.timeline({
            defaults: {
                ease: "power2.out",
                duration: 0.5
            },
            onComplete: () => {
                // Clear inline styles after animation but preserve overflow and border-radius
                [formHeader, ...formImages, ...formGroups, formButtons].forEach(el => {
                    if (el) gsap.set(el, { clearProps: "opacity,y,transform,x,scale" });
                });
            }
        });

        // Animate header first
        if (formHeader) {
            tl.fromTo(formHeader, 
                { opacity: 0, y: -20 },
                { opacity: 1, y: 0, duration: 0.4 }, 
                0.1
            );
        }

        // Animate images
        if (formImages.length > 0) {
            tl.fromTo(formImages, 
                { opacity: 0, scale: 0.9, y: 20 },
                { 
                    opacity: 1, 
                    scale: 1, 
                    y: 0,
                    stagger: 0.08,
                    duration: 0.5,
                    ease: "back.out(1.2)"
                }, 
                0.2
            );
        }

        // Animate form groups (inputs, textareas, etc.)
        if (formGroups.length > 0) {
            tl.fromTo(formGroups, 
                { opacity: 0, y: 30 },
                { 
                    opacity: 1, 
                    y: 0,
                    stagger: 0.1,
                    duration: 0.6,
                    ease: "power3.out"
                }, 
                0.3
            );
        }

        // Animate footer buttons last
        if (formButtons) {
            tl.fromTo(formButtons, 
                { opacity: 0, y: 20 },
                { 
                    opacity: 1, 
                    y: 0,
                    duration: 0.5,
                    ease: "back.out(1.5)"
                }, 
                "-=0.3"
            );
        }
    }

    // Function to hide edit modal
    function hideEditModal() {
        gsap.to(editModal, {
            opacity: 0,
            duration: 0.3,
            ease: "power2.out",
            onComplete: function () {
                editModal.classList.remove("show");
                // Restore body scroll
                document.body.style.overflow = "";
                
                // Restore scroll on theme preview and card content
                const themePreview = document.getElementById("themePreview");
                const invitationCard = document.getElementById("invitationCard");
                const cardWrapper = document.querySelector(".card-wrapper");
                
                if (themePreview) {
                    themePreview.classList.remove("modal-open");
                }
                if (invitationCard) {
                    invitationCard.classList.remove("modal-open");
                }
                if (cardWrapper) {
                    cardWrapper.classList.remove("modal-open");
                }
                
                // After hiding the edit modal, show the theme information model
                if (typeof window.showModel === 'function') {
                    try {
                        window.showModel('theme-information-tab');
                    } catch (err) {
                        console.error('Failed to show theme-information-tab model via showModel()', err);
                    }
                } else {
                    // Fallback: directly set data-state on the theme-information-tab model if present
                    const themeInfoModel = document.querySelector('[data-model="theme-information-tab"]');
                    if (themeInfoModel) {
                        themeInfoModel.setAttribute('data-state', 'show');
                    }
                }
            },
        });
    }

    // Edit button click
    editBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        // Meta Pixel — CustomizeProduct fires once when the user clicks "Customize Theme"
        if (!editBtn._pixelCustomizeTracked && typeof fbq !== 'undefined') {
            fbq('track', 'CustomizeProduct');
            editBtn._pixelCustomizeTracked = true;
        }
        showEditModal();
    });

    // Close button click
    closeEditBtns.forEach(closeEditBtn => {
        closeEditBtn.addEventListener("click", function (e) {
            e.stopPropagation();
            hideEditModal();
        });
    });

    // Close on escape key
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && editModal.classList.contains("show")) {
            hideEditModal();
        }
    });

    // Close on backdrop click
    editModal.addEventListener("click", function (e) {
        if (e.target === editModal) {
            hideEditModal();
        }
    });
}

